export const filterSelectedValues = (options: number[] = [], selectedValues: number[] = []): number[] => {
  if (!Array.isArray(options) || !Array.isArray(selectedValues)) return [];
  return selectedValues.filter((value) => options.includes(value));
};
